import { render, staticRenderFns } from "./BaseHeader.vue?vue&type=template&id=66215a40&scoped=true&"
import script from "./BaseHeader.vue?vue&type=script&lang=js&"
export * from "./BaseHeader.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./BaseHeader.vue?vue&type=style&index=0&id=66215a40&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "66215a40",
  null
  ,true
)

export default component.exports